import * as React from 'react';

import {
  ISetRedundantSupply,
  ISetSlotRouterItemFront,
  IUpdatePowerSupply,
  IUpdateProSupport,
  IUpdateSlotsWithNumber
} from '../../actions';
import { IAvailablePower } from '../../types/store/availablePower';
import { IBudget } from '../../types/store/budget';
import { IRouterData } from '../../types/store/routerData';
import { ISlotItemPort, ISlotsItems } from '../../types/store/slotsItems';
import { getOccupedPortsBySlotNumberByPortItem } from '../../utils/manageRouterSlots';
import { getAvailableGs, getMaxGs } from './../../utils/manageGs';
import FormConfigurator from './FormConfigurator';
import ModalConfigurator from './ModalConfigurator';

interface IConfiguratorProps {
  routerData: IRouterData;
  slotsItems: ISlotsItems;
  budget: IBudget;
  availablePower: IAvailablePower;
  updateSlotsWithNumber: IUpdateSlotsWithNumber;
  updatePowerSupply: IUpdatePowerSupply;
  updateProSupport: IUpdateProSupport;
  setRedundantSupply: ISetRedundantSupply;
  setSlotRouterItemFront: ISetSlotRouterItemFront;
}

export interface ISlotInfo {
  id: string;
  maxGs: number;
  maxGsAvailable: number;
  gsByPort: number;
  portsInRouter: number;
  portsBySlot: number;
  label: string;
  slotItem: ISlotItemPort;
}

const getItemSlotsInfo = (routerData: IRouterData, budget: IBudget, slotsItems: ISlotsItems): ISlotInfo[] =>
  routerData.portsSupported.map(slotItemID => {
    const item = slotsItems[slotItemID] as ISlotItemPort;
    const slotsRouter = routerData.slots.front.slotsSpecs;
    const slotsBudget = budget.slots.front.slotsSpecs;
    return {
      id: slotItemID,
      maxGs: getMaxGs(item.usedBy, slotsRouter),
      maxGsAvailable: getAvailableGs(item.usedBy, slotsRouter, slotsBudget),
      gsByPort: item.gsByPort,
      portsInRouter: getOccupedPortsBySlotNumberByPortItem(item, slotsBudget),
      portsBySlot: item.portsBySlot,
      label: item.howMuchLabel,
      slotItem: item
    };
  });

const Configurator: React.SFC<IConfiguratorProps> = props => {
  const slotsInfo: ISlotInfo[] = getItemSlotsInfo(props.routerData, props.budget, props.slotsItems);

  return (
    <div className="row">
      <FormConfigurator
        {...{
          slotsInfo,
          updateSlotsWithNumber: props.updateSlotsWithNumber,
          budget: props.budget,
          slotsItems: props.slotsItems,
          updatePowerSupply: props.updatePowerSupply,
          updateProSupport: props.updateProSupport,
          setRedundantSupply: props.setRedundantSupply
        }}
      />
      <ModalConfigurator
        {...{
          routerData: props.routerData,
          slotsItems: props.slotsItems,
          budget: props.budget,
          availablePower: props.availablePower,
          setSlotRouterItem: props.setSlotRouterItemFront,
          setRedundantSupply: props.setRedundantSupply,
          updatePowerSupply: props.updatePowerSupply
        }}
      />
    </div>
  );
};
export default Configurator;



// WEBPACK FOOTER //
// ./src/components/Configurator/index.tsx